// extracted by mini-css-extract-plugin
module.exports = {"underlineText":"Hg49e5KD"};